import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import QueryString from 'qs';
import { Component } from 'react';

import { ColorInfo } from './ColorInfo';
import ColorSwatch from './ColorSwatch';
import ImageView from './ImageView';
import { PerformanceBadges } from './PerformanceBadges';
import SelectedTitle from './SelectedTitle';
import Icon from '../../../OC/oc-icon.jsx';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const LoadingIconContainer = styled.div`
  display: inline-flex;
  justify-content: center;
  padding: 2em 0;
  position: relative;
  width: 100%;

  span {
    animation: ${spin} 1.2s linear infinite;
    display: inline-block;
    font-size: 4em;
    position: relative;
  }
`;

const ShingleWidgetContainer = styled.div`
  display: table;
  margin-left: auto;
  margin-right: auto;
  max-width: 720px;
  position: relative;
  width: 100%;

  @media (min-width: 768px) {
    padding-top: 2em;
  }

  &.widget-layout-row {
    @media (min-width: 768px) {
      max-width: 750px;
    }

    @media (min-width: 1050px) {
      max-width: 1010px;
    }

    @media (min-width: 1200px) {
      max-width: 1170px;
    }
  }

  &.hidden {
    overflow: hidden;
    position: relative;
    z-index: 100;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ffffff;
      opacity: 1;
      z-index: 999;
    }
  }
`;

const Row = styled.div`
  margin-left: -15px;
  margin-right: -15px;
`;

const ShingleWidgetContent = styled.div`
  display: inline-block;
  float: left;
  margin-bottom: 1em;
  padding-left: 15px;
  padding-right: 15px;
  position: relative;
  width: 100%;

  &.primary {
    @media (min-width: 768px) {
      width: 33.333%;
    }
  }

  &.primary + & {
    @media (min-width: 768px) {
      width: 66.666%;
    }
  }

  &.primary,
  &.primary + & {
    @media (min-width: 1050px) {
      width: 50%;
    }
  }
`;

const ShingleDetailsWrap = styled.div`
  border-bottom: 1px solid #000000;
  margin-bottom: 0.5em;
  padding-bottom: 0.5em;
  display: flex;
  flex-direction: column-reverse;

  @media (min-width: 768px) {
    flex-direction: column;
  }

  .color-control-wrap {
    margin-bottom: 0.75em;
  }
`;

const SwatchList = styled.ul`
  display: inline-block;
  list-style: none;
  margin: 0 -0.25em;
  padding: 0;
  position: relative;
  width: calc(100% + 0.5em);
`;

const Disclaimer = styled.p`
  font-size: 0.75em;
  line-height: 1.4em;
`;

export default class ShingleColorDetail extends Component {
  constructor(props) {
    super(props);

    const filteredColors =
      (props.allowedColors &&
        props.allowedColors.length > 0 &&
        props.shingleColors.filter(sc => props.allowedColors.includes(sc.uid))) ||
      props.shingleColors;

    this.state = {
      layout: this.props.layout,
      style: this.props.style,
      selectedImageView: this.props.view,
      selectedSwatch: filteredColors[0],
      colors: filteredColors,
      visibility: 'hidden',
      trudefinition: this.props.trudefinition,
    };
    this.onImageViewToggle = this.onImageViewToggle.bind(this);
    this.onSwatchToggle = this.onSwatchToggle.bind(this);
    this.onImageViewZoom = this.onImageViewZoom.bind(this);
  }

  onImageViewZoom(a) {
    console.log(a);
  }

  onImageViewToggle(selectedView) {
    this.setState({ selectedImageView: selectedView });
  }

  onSwatchToggle(colorData, selected) {
    this.setState({
      selectedSwatch: selected ? colorData : this.state.selectedSwatch,
    });
  }

  componentDidMount() {
    const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
    this.setState({ layout: query.layout || 'row' });
    this.setState({ selectedImageView: query.view || this.props.view });

    const {
      shingle: { uid },
    } = this.props;

    if (uid === 'berkshire') {
      console.log('Hidden widget for berkshire shingle');
    } else {
      this.setState({ visibility: 'visible' });
    }
  }

  render() {
    const images = [];
    {
      this.state.colors.map(shingleColor => {
        images.push(shingleColor.house_1229x768_url);
        images.push(shingleColor.swatch_768x485_url);
        images.push(shingleColor.swatch_768x768_url);
        images.push(shingleColor.ranch_house_image_url);
        images.push(shingleColor.two_story_house_v1_image_url);
        images.push(shingleColor.two_story_house_v2_image_url);
      });
    }

    return (
      <ShingleWidgetContainer className={`widget-layout-${this.state.layout} ${this.state.visibility}`}>
        <Row>
          <div className="scroll-fixed">
            <ShingleWidgetContent className={this.state.layout == 'row' ? 'primary' : ''}>
              <ImageView
                className="tablet-desktop-only"
                onToggle={this.onImageViewToggle}
                onZoom={this.onImageViewZoom}
                selectedView={this.state.selectedImageView}
                shingleColor={this.state.selectedSwatch}
                selectedStyle={this.state.style}
              />
            </ShingleWidgetContent>
            <ShingleWidgetContent>
              <SelectedTitle
                shingleName={this.props.shingleName}
                colorName={this.state.selectedSwatch.name}
                trudefinition={this.state.trudefinition}
                shingle={this.props.shingle}
              />
              <PerformanceBadges shingle={this.props.shingle} />
              <ImageView
                className="mobile-only"
                onToggle={this.onImageViewToggle}
                onZoom={this.onImageViewZoom}
                selectedView={this.state.selectedImageView}
                shingleColor={this.state.selectedSwatch}
                selectedStyle={this.state.style}
              />
              <ShingleDetailsWrap>
                <div className="color-control-wrap">
                  <SwatchList>
                    {this.props.loading ? (
                      <LoadingIconContainer>
                        <Icon type="spinner" />
                      </LoadingIconContainer>
                    ) : (
                      this.state.colors.map(function (shingleColor) {
                        return (
                          <ColorSwatch
                            onToggle={this.onSwatchToggle}
                            key={shingleColor.uid}
                            colorData={shingleColor}
                            selected={shingleColor.uid === this.state.selectedSwatch.uid}
                            tracking={{
                              'data-track': 'view-product',
                              'data-track-product-name': `${this.props.shingleLine}-${shingleColor.uid}`,
                              'data-track-product-color': shingleColor.name,
                            }}
                          />
                        );
                      }, this)
                    )}
                  </SwatchList>
                </div>
                <ColorInfo selectedSwatch={this.state.selectedSwatch} />
              </ShingleDetailsWrap>
              <Disclaimer>
                We strive to accurately reproduce all photographs of shingles in literature and for onscreen viewing.
                The roofing product colors you see are as accurate as technology allows. To accurately judge your
                shingle and color choice, we recommend that you view it on an actual roof with a pitch similar to your
                own roof prior to making your final color selection.
              </Disclaimer>
            </ShingleWidgetContent>
          </div>
        </Row>
      </ShingleWidgetContainer>
    );
  }
}
